<!-- KYMW4602 タグ一括設定 -->
<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">タグ一括設定</th>
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area">
        <div class="element-column">
          <div class="column-list">
            <!-- タグ名 -->
            <label class="list-input-title">タグ名</label>
            <div class="list-input-content">
              <input type="text" readonly [value]="model.tagName" [style.width.px]="340" [tabindex]="-1" />
            </div>
          </div>
          <!-- Pコード -->
          <div class="input_vertical list_search">
            <div class="layout_balance">
              <label class="list-input-title" style="min-width: 105px;">Ｐコード</label>
              <!-- 件数 -->
              <label class="count-field">{{getCounter()}}</label>
            </div>
            <div class="element-row">
              <app-not-null-text-area #txt_PCodes [maxChars]="9000" [height]="436" [width]="240"
                [restrict]="'[P0-9\n]'" [allowMultiLine]="true" [tabEnabled]="true" [tabindex]="0"
                [verticalScrollPolicy]="'auto'" [(ngModel)]="model.PCodes"
                [displayCountField]="false"></app-not-null-text-area>
              <!-- 注釈 -->
              <div class="element-column">
                <label>・１行１件のＰコードを入力してください。</label>
                <label>・一度に入力できるＰコードは最大{{getMax()}}件までとします。</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <!-- フッター -->
  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <!-- button 設定 -->
          <button #btn_SetPCode id="btn_SetPCode" class="btn-primary" (click)="setPCodes()" [tabindex]="0">設定</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>

</table>